module.exports = __webpack_public_path__ + "img/facebook-icon.893e4704.svg";